import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState(['screenWidth']),
    ...mapGetters(['isLargeScreen']),
  },
}
